module.exports = __webpack_public_path__ + "img/project-traveljournal-3.74f2d6e1.png";